import React from 'react';
import ReactDOM from 'react-dom/client';
import SnfApp from './SnfApp';

import './index.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<SnfApp />);
